import { gql } from '@apollo/client'

export const FINISH_TEST_SESSION_PAYMENT = gql`
  mutation FinishTestSessionPayment($stripePaymentId: String!, $paymentError: String) {
    finishTestSessionPayment(stripePaymentId: $stripePaymentId, paymentError: $paymentError)
  }
`
